import { clearLegacyCookie } from './cookies';
const USER_AUTH_TOKEN = 'wch_ux_auth_token';

export const getToken = () => localStorage.getItem(USER_AUTH_TOKEN);

export const setToken = token => localStorage.setItem(USER_AUTH_TOKEN, token);

export const removeToken = () => localStorage.removeItem(USER_AUTH_TOKEN);

export const isAuthenticated = () => !!getToken();

export const clearSessionStorage = () => {
  removeToken();
  clearLegacyCookie();
};



// WEBPACK FOOTER //
// ./src/utils/auth.js